import { render, staticRenderFns } from "./ThemeWysiwyg.vue?vue&type=template&id=a52b5dde"
import script from "./ThemeWysiwyg.vue?vue&type=script&lang=js"
export * from "./ThemeWysiwyg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports